import styled from 'styled-components';

const Text = styled.p`
  font-size: ${props => props.fontSize}px;
  color: ${({ theme, color }) => theme.colors[color]};
`;

export default Text;
